module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/dividers/divider-vertical-2-f3bd3cedfb8d3f90b23aeb9fe1f23fc5.svg";